// Gatsby requirements
import React from "react"
import { storyblokEditable } from "gatsby-source-storyblok";

// Components
import SectionText from "./SectionText"
import SectionCard from "./SectionCard"
import SectionCta from "./SectionCta"
import SectionTable from "./SectionTable"
import Image from "utils/Image"

// CSS
import * as CSS from './Section.module.scss'


const Section = ({ data }) => {

    const length = data?.rowOfElements?.length;
    const margin = data?.margin;

    // This component enables putting items next to each other on the same section/row.

    return (
        <section
            className={`
                ${CSS.section}
                ${'section' + data._uid}
                ${data.reverseOrderOnMobile ? CSS.reverse : ''}
                ${
                    data.margin === 'Extra margin at top' ?
                    CSS.extraMarginTop : margin === 'Extra margin at bottom' ?
                    CSS.extraMarginBottom : ''
                }
            `}
            style={{backgroundColor: data?.backgroundColor}}
            {...storyblokEditable(data)}
        >

            {data?.css &&
                <style dangerouslySetInnerHTML={{__html:
                    data.css.replaceAll('.section', '.section' + data._uid)
                }} />
            }
            
            {data?.rowOfElements && data?.rowOfElements.map((column, i) => {
                switch (column.component) {

                    case "Section Item: Text":
                        return (
                            <div
                                key={i}
                                className={`
                                    ${length === 1 ? CSS.full : CSS.half}
                                    ${column?.margin === 'Small' ? CSS.smallTextMargin : ''}
                                    ${CSS.text}
                                    ${'section' + column._uid}
                                `}
                                {...storyblokEditable(column)}
                            >
                                <div className={CSS.wrapper}>
                                    <SectionText content={column} />
                                </div>
                            </div>
                        )

                    case "Section Item: Table":
                        return (
                            <div
                                key={i}
                                className={`${length === 1 ? CSS.full : CSS.half} ${CSS.table}`}
                                {...storyblokEditable(column)}
                            >
                                <div className={CSS.wrapper}>
                                    <SectionTable content={column} />
                                </div>
                            </div>
                        )

                    case "Section Item: Image":
                        return (
                            <div
                                key={i}
                                className={`
                                    ${length === 1 ? CSS.full : CSS.half}
                                    ${column.imageSize === 'Large' ? CSS.widerImage : ''}
                                    ${column.imageSize === 'Small' ? CSS.smallerImage : ''}
                                    ${'section' + column._uid}
                                `}
                                {...storyblokEditable(column)}
                            >

                                {column?.css &&
                                    <style dangerouslySetInnerHTML={{__html:
                                        column.css.replaceAll('.section', '.section' + column._uid).replaceAll('.image', '.image' + column._uid)
                                    }} />
                                }

                                <div
                                    className={`${CSS.wrapper} ${'image' + column._uid}`}
                                    style={{alignItems: column?.alignImage === 'Center' ? 'center' : 'flex-end'}}
                                >
                                    <Image style={{display: 'block'}} img={column?.image} loading={column?.eagerLoading && 'eager'} />
                                </div>
                            </div>
                        )

                    case "Section Item: Empty Space":
                        return (
                            <div 
                                key={i}
                                className={`${CSS.emptySpace} ${length === 1 ? CSS.full : CSS.half}`}
                                {...storyblokEditable(column)}
                            >
                            </div>
                        )

                    case "Section Item: Cta":
                        return (
                            <div
                                key={i}
                                className={`${length === 1 ? CSS.full : CSS.half}`}
                                {...storyblokEditable(column)}
                            >
                                <div className={CSS.wrapper}>
                                    <SectionCta content={column} />
                                </div>
                            </div>
                        )

                    case "Section Item: Card":
                        return (
                            <div
                                key={i}
                                className={`
                                    ${length === 1 ? CSS.full : CSS.half}
                                    ${CSS.card}
                                    ${'section' + column._uid}
                                    ${column?.style === 'Pricing' && CSS.pricing}
                                `}
                                {...storyblokEditable(column)}
                            >
                                <div className={CSS.wrapper}>
                                    <SectionCard content={column} />
                                </div>
                            </div>
                        )

                    default:
                    return false
                }})
            }
        </section>
    )
}

export default Section
